module.exports = __webpack_public_path__ + "static/bristol-cc-6516820010945a00e72422ede20b7cc2.png";